import React, { useState } from "react";
import { Controller } from "react-hook-form";
import ReactSelect from "react-select";
import { Button, Card, CardBody, TableCell, TableRow, useDisclosure } from "@nextui-org/react";
import { PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import useSWR from "swr";
import { getFetcher } from "../../../../../services/api";
import ClientTablePagination from "../../../../elements/ClientTablePagination";
import AddTransporterModal from "../../transporter/AddTransporterModal";

export default function InlineEditTransporter({ selectedTransporters, selectedCompany, control, setValue, isDisabled = false }) {
  const { isOpen: isOpenModalForm, onOpen: onOpenModalForm, onOpenChange: onOpenChangeModalForm, onClose: onCloseModalForm } = useDisclosure();
  const [selectedItems, setSelectedItems] = useState(selectedTransporters?.map((item) => ({ value: item.dataTransporter?.id, label: item.dataTransporter?.namaTransPorter })) || []);
  const [detailSelectedItem, setDetailSelectedItem] = useState(selectedTransporters?.map((item) => item.dataTransporter) || []);
  const header = ["Nama Perusahaan", "Alamat", "Actions"];

  const content = (item) => (
    <TableRow key={item.id}>
      <TableCell>{item.namaTransPorter}</TableCell>
      <TableCell>{item.alamat}</TableCell>
      <TableCell className="flex items-center gap-1">
        <Button size="sm" onPress={() => handleDeleteItem(item.id)} color="danger" isIconOnly>
          <TrashIcon className="size-4" />
        </Button>
      </TableCell>
    </TableRow>
  );

  const { data: dataTransporter, isLoading: isLoadingTransporter, mutate: mutateTransporter } = useSWR(selectedCompany ? `/api/company/search-data-transporter?companyId=${selectedCompany}` : null, getFetcher);

  function handleSuccess(response) {
    const newItem = { value: response.id, label: response.namaTransPorter };
    setSelectedItems((prevItems) => [...prevItems, newItem]);
    setDetailSelectedItem((prevItems) => [...prevItems, response]);
    setValue(
      "dataTransporters",
      [...selectedItems, newItem].map((item) => item.value),
    );
  }

  function handleDeleteItem(id) {
    const updatedItems = selectedItems.filter((item) => item.value !== id);
    const updatedDetail = detailSelectedItem.filter((item) => updatedItems.some((uItem) => uItem.value === item.id));
    setDetailSelectedItem(updatedDetail);
    setSelectedItems(updatedItems);
    setValue(
      "dataTransporters",
      updatedItems?.map((item) => item.value),
    );
  }

  function handleSelectChange(options) {
    const opt = options.map((item) => item.value);
    const filteredData = dataTransporter?.data?.filter((item) => opt.includes(item.id));
    setDetailSelectedItem(filteredData);
    setSelectedItems(options || []);
    setValue("dataTransporters", opt);
  }

  return (
    <div className="flex flex-col">
      <Card radius="sm">
        <CardBody>
          <div className="flex items-end gap-3">
            <div className="flex-1">
              <Controller
                name="dataTransporters"
                control={control}
                render={({ field, fieldState }) => (
                  <div className="flex flex-col">
                    <label className={`text-sm mb-2 ${isDisabled ? "opacity-50" : ""}`}>
                      Perusahaan Transporter <span className="text-danger">*</span>
                    </label>
                    <ReactSelect
                      {...field}
                      isDisabled={isDisabled}
                      isMulti
                      placeholder="Pilih..."
                      options={dataTransporter?.data?.map((item) => ({ value: item.id, label: item.namaTransPorter }))}
                      isLoading={isLoadingTransporter}
                      value={selectedItems}
                      onChange={handleSelectChange}
                      menuPosition="fixed"
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 10,
                        borderWidth: 4,
                        colors: {
                          ...theme.colors,
                          primary25: "#EBF2F0",
                        },
                      })}
                      styles={{
                        menu: (styles) => ({ ...styles, zIndex: 999 }),
                        control: (styles) => ({ ...styles, backgroundColor: "#EBF2F0" }),
                        option: (styles) => ({ ...styles, color: "#51625E", fontSize: "10pt" }),
                        placeholder: (styles) => ({ ...styles, color: "#51625E", fontSize: "10pt" }),
                        multiValue: (styles) => ({ ...styles, backgroundColor: "#C7D2CF", borderRadius: 5 }),
                        indicatorSeparator: (styles) => ({ ...styles, alignSelf: "stretch", marginBottom: 8, marginTop: 8, width: 2, backgroundColor: "#E1E8E6" }),
                      }}
                    />
                    {fieldState.error && <p className="text-danger text-xs">{fieldState.error.message}</p>}
                  </div>
                )}
              />
            </div>
            <Button isDisabled={isDisabled} onPress={onOpenModalForm} color="primary" startContent={<PlusIcon className="size-4" />}>
              Tambah Perusahaan Transporter
            </Button>
          </div>
          <div className="mt-4">
            <ClientTablePagination header={header} data={detailSelectedItem} content={content} />
          </div>
        </CardBody>
      </Card>

      <AddTransporterModal isOpen={isOpenModalForm} onOpenChange={onOpenChangeModalForm} onClose={onCloseModalForm} selectedCompany={selectedCompany} onSuccess={handleSuccess} mutateTransporter={mutateTransporter} />
    </div>
  );
}
